import { useEffect } from 'react'

export function useSource() {
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const source = urlParams.get('source')
    if (source) {
      localStorage.setItem('source', source)
    }
    const internal = urlParams.get('_internal')
    if (internal) {
      localStorage.setItem('source', 'internal')
    }
  }, [])
}
